import React, { useState, createContext } from "react";

export const SearchContext = createContext();

export const SearchProvider = (props) => {
  const [searchParameter, setSearchParameter] = useState("");

  return (
    <SearchContext.Provider value={[searchParameter, setSearchParameter]}>
      {props.children}
    </SearchContext.Provider>
  );
};
